import {
  sendOrderProposal,
  getOrderDetails,
  getOrderProposals,
} from './actions';
import { getHandymanOrderProposals } from './actions';

type Args = {
  dispatch: any;
  orderId: string;
  handymanId: string;
  role: string;
  onSuccess?: () => void;
  onError?: (e: unknown) => void;
};

export async function selectHandymanForOrder({
  dispatch,
  orderId,
  handymanId,
  role,
  onSuccess,
  onError,
}: Args) {
  try {
    await dispatch(sendOrderProposal(orderId, handymanId) as any);

    await dispatch(getOrderDetails(orderId) as any);

    if (role === 'customer') {
      await dispatch(getOrderProposals(orderId) as any);
    } else if (role === 'handyman') {
      await dispatch(getHandymanOrderProposals(orderId) as any);
    }

    onSuccess?.();
  } catch (e) {
    onError?.(e);
    throw e;
  }
}
